import { FC } from "react";
import styles from "./BoostHint.module.sass";

type BoostHintProps = {
    children?: React.ReactNode;
};

export const BoostHint: FC<BoostHintProps> = ({ children }) => {
  return <div className={styles.boostHint}>{ children }</div>
}